import Vue from 'vue'
import VueRouter from 'vue-router'
import Start from '../views/start/View.vue'
import Invoice from '../views/invoice/View.vue'
import SearchNote from '../views/invoice/search-note/View.vue'
import SearchClient from '../views/invoice/search-client/View.vue'
import CreateInvoice from '../views/invoice/create-invoice/View.vue'
import Thanks from '../views/thanks/View.vue'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        redirect: { name: 'Start'}
    }, {
        path: '/start',
        name: 'Start',
        component: Start
    }, {
        path: '/invoice',
        name: 'Invoice',
        component: Invoice,
        redirect: {name: 'SearchNote'},
        children: [
            {
                path: 'search-note',
                name: 'SearchNote',
                component: SearchNote
            }, {
                path: 'search-client',
                name: 'SearchClient',
                component: SearchClient
            },
            {
                path: 'create-invoice',
                name: 'CreateInvoice',
                component: CreateInvoice
            },
        ]
    }, {
        path: '/thanks',
        name: 'Thanks',
        component: Thanks,
        props: (route) => ({
            email: route.params.email,
            uuid: route.params.uuid,
            xml: route.params.xml,
            pdf: route.params.pdf
        })
    },


]

const router = new VueRouter({
    routes,
    linkActiveClass: 'active',
    linkExactActiveClass: 'active'

})

export default router
